import React from 'react'
import styled from 'styled-components/macro'
import isArray from 'lodash/fp/isArray'
import isPlainObject from 'lodash/fp/isPlainObject'
import isString from 'lodash/fp/isString'
import isEmpty from 'lodash/fp/isEmpty'
import getOr from 'lodash/fp/getOr'
import compose from 'lodash/fp/compose'
import { em } from '../../../utils/styles'
import { InputWrapper } from '../Input';
import InputAdornment from '../Input/InputAdornment'

const FileFieldBase = styled.input.attrs({
  type: 'file'
})`
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
`
const FileFieldText = styled.span`
  min-height: ${em(35)};
  padding: ${em(6)} 0;
  flex: 1;
`

const isControlled = (key, props) => props[key] !== undefined
const callIf = fn => (...args) => fn && fn(...args)
const checkFilled = value => {
  if (isArray(value) || isPlainObject(value) || isString(value)) {
    return !isEmpty(value)
  }
  return value != null
}
const isFilled = compose(checkFilled, getOr('', 'value'))

class FileField extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    if (
      isControlled('value', this.props) &&
      prevProps.value !== this.props.value
    ) {
      this.checkDirty(this.props)
    }
  }

  checkDirty(obj) {
    if (isFilled(obj)) {
      callIf(this.props.onFilled)()
      return
    }
    callIf(this.props.onEmpty)()
  }

  render() {
    const {
      name,
      id = name,
      label,
      shrinkLabel,
      filled,
      focused,
      full,
      value,
      prefix,
      suffix,
      error,
      disabled,
      onFilled: ignoredOnFilled,
      onEmpty: ignoredOnEmpty,
      ...props
    } = this.props

    return (
      <InputWrapper
        full={full}
        filled={filled}
        focused={focused}
        disabled={disabled}
        error={error}
      >
        {prefix && <InputAdornment position='start'>{prefix}</InputAdornment>}
        <FileFieldText>{value && value.name}</FileFieldText>
        <FileFieldBase
          {...props}
          ref={this.fieldRef}
          name={name}
          id={id}
          focused={focused}
          error={error}
          disabled={disabled}
        />
        {suffix && <InputAdornment position='end'>{suffix}</InputAdornment>}
      </InputWrapper>
    )
  }
}

export default FileField
